import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Vue, PropSync, Prop } from "vue-property-decorator";
// import { decorationData, questionData, testData, QuestionDataType } from "../../config/questionnaire";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
let QuestionnaireEdit = class QuestionnaireEdit extends Vue {
  constructor() {
    super(...arguments);
    this.ifItems = [];
    this.noneDecoItems = [];
    this.localSubmit = {};
    this.postForm = {
      itemShowLogics: []
    };
  }
  // private rules = {
  //   title: [{ required: true, type: "string", message: "请填写标题", trigger: "blur" }],
  // };
  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }
  get dataList() {
    return QuestionnaireEditModule.dataList;
  }
  // get formLogicConfig() {
  //   return QuestionnaireEditModule.formLogicConfig;
  // }
  onOpen() {
    console.log("sf sdf onOpen ");
    this.initPostForm();
    this.initIfItems();
  }
  deleteLogic(index) {
    this.postForm.itemShowLogics.splice(index, 1);
  }
  addLogic() {
    //
    this.postForm.itemShowLogics.push({
      ifItem: "",
      itemOptions: [],
      nextItem: [],
      nextResult: [],
      ifItemIndex: "",
      ifItemIsRadio: false,
      ifItemOptions: []
    });
  }
  ifItemChange(value, index) {
    console.log("ifItemChange", value, index);
    if (value) {
      let oifItemIndex = this.dataList.findIndex(item => {
        return item.data.id == value;
      });
      if (oifItemIndex >= 0) {
        this.postForm.itemShowLogics[index].ifItemIndex = oifItemIndex;
        const oifItem = this.dataList[oifItemIndex];
        this.postForm.itemShowLogics[index].itemOptions = [];
        this.postForm.itemShowLogics[index].nextItem = [];
        this.postForm.itemShowLogics[index].ifItemOptions = oifItem.data.optionsList;
        this.postForm.itemShowLogics[index].ifItemIsRadio = oifItem.data.type == 1 || oifItem.data.type == 9;
      }
    }
  }
  thenEffectChange(value, index) {
    if (value == "HIDEALL") {
      this.postForm.itemShowLogics[index].nextItem = [];
    }
  }
  validateIfItem(rule, value, callback) {
    let ifitemExist = this.noneDecoItems.some(nitem => {
      return nitem.data.id == value;
    });
    if (!ifitemExist) {
      callback(new Error("该选项已失效"));
    } else {
      callback();
    }
  }
  validateItemOptions(rule, value, callback) {
    let logicIndex = rule.field.split(".")[1];
    let ifItemOptions = this.postForm.itemShowLogics[logicIndex].ifItemOptions;
    console.log(" validateItemOptions", value, logicIndex, ifItemOptions);
    const itemExist = value.every(id => {
      return ifItemOptions.some(op => {
        return op.id == id;
      });
    });
    if (!itemExist) {
      callback(new Error("该选项已失效"));
    } else {
      callback();
    }
  }
  validatenextResult(rule, value, callback) {
    // let sameLogic = this.postForm.itemShowLogics.filter((item: any) => {
    //   return item.nextItem == value;
    // });
    // if (sameLogic.length > 1) {
    //   callback(new Error("与已有逻辑冲突，请重新设置"));
    // } else {
    // console.log("validateNextItem", rule.field);
    if (rule.field) {
      let findEmpty = value.some(id => {
        return !this.resultList.some(nitem => {
          return nitem.id == id;
        });
      });
      if (findEmpty) {
        return callback(Error("操作项目已失效 请重选"));
      }
      return callback();
    }
    // }
  }
  initIfItems() {
    let dataList = JSON.parse(JSON.stringify(this.dataList));
    this.noneDecoItems = dataList.filter(item => {
      return ![15, 16, 5, 8, 24].includes(item.componentName);
    });
    this.noneDecoItems.forEach((item, index) => {
      item.index = index + 1;
    });
    this.ifItems = dataList.filter(item => {
      return [1, 2, 9, 10].includes(item.componentName);
    });
  }
  getFormInstance() {
    return this.$refs.postForm;
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
  initPostForm() {
    let postForm = {
      itemShowLogics: JSON.parse(JSON.stringify(this.ruleList))
    };
    postForm.itemShowLogics.forEach(logic => {
      if (logic.ifItem) {
        let oifItemIndex = this.dataList.findIndex(item => {
          return item.data.id == logic.ifItem;
        });
        if (oifItemIndex >= 0) {
          logic.ifItemIndex = oifItemIndex;
          logic.ifItemOptions = this.dataList[oifItemIndex].data.optionsList;
        } else {
          logic.ifItemIndex = 0;
          logic.ifItemOptions = [];
        }
      } else {
        logic.ifItemIndex = 0;
        logic.ifItemOptions = [];
      }
    });
    this.postForm = postForm;
  }
  // $ handleModules
  getModulesConfigInstance() {
    return this.$refs.modulesConfig;
  }
  getSubmitConfigInstance() {
    return this.$refs.submitConfig;
  }
  async validateForSave() {
    // 保存总配置时,用来最终效验有没有失效项目
    this.clearValidate();
    console.log("logicSetvalidateForSave");
    this.initPostForm();
    this.initIfItems();
    return await this.validate();
  }
  async validate() {
    console.log("logicSetvalidateForSave1", this.postForm, this.ruleList);
    if (this.postForm.itemShowLogics.length == 0) {
      return true;
    }
    console.log("logicSetvalidateForSave12");
    if (!this.getFormInstance()) {
      // this.$message.warning("请检查规则设置");
      this.visible = true;
      return false;
    }
    console.log("logicSetvalidateForSave3");
    let result = await this.getFormInstance().validate().catch(() => {
      return false;
    });
    console.log("logicSetvalidateForSave4", result);
    if (result) {
      // QuestionnaireEditModule.SET_FORM_LOGIC_CONFIG(this.postForm);
    }
    return result;
  }
  closeDialog() {
    this.initPostForm();
    this.visible = false;
  }
  async handleCommit() {
    let vali = await this.validate();
    console.log("validate", vali);
    if (vali) {
      this.visible = false;
      this.$emit("success", JSON.parse(JSON.stringify(this.postForm.itemShowLogics)));
    }
  }
};
__decorate([PropSync("modalVisible", {
  type: Boolean
})], QuestionnaireEdit.prototype, "visible", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], QuestionnaireEdit.prototype, "disabled", void 0);
__decorate([Prop({
  type: Array,
  default: () => {
    return [];
  }
})], QuestionnaireEdit.prototype, "ruleList", void 0);
__decorate([Prop({
  type: Array,
  default: () => {
    return [];
  }
})], QuestionnaireEdit.prototype, "resultList", void 0);
QuestionnaireEdit = __decorate([Component({
  name: "resultListDialog",
  components: {},
  filters: {}
})], QuestionnaireEdit);
export default QuestionnaireEdit;